import http from "./http";
const article = {

    getArticleBaseInfo(articleId) {
        return http.get('article/article/getArticleBaseInfo?articleId=' + articleId)
    },

    getProcessList(articleId) {
        return http.get('article/article/getProcessList?articleId=' + articleId)
    },

    //已录用稿件列表（编辑、查重人员）
    articleEmployedList(page, size, order, sort, model,type) {
        return http.post('article/Article/articleEmployedList?page=' + page + "&size=" + size + "&order=" + order + "&sort=" + sort+"&type="+type, model)
    },

    //下载已录用稿件附件
    downloadAttachEmployed(ids) {
        let modal = {
            articleIds: ids,
        };
        return http.post("article/article/downloadDuplicate", modal, { responseType: 'blob' });
    },

    //导出已录用稿件记录表
    exportXlsEmployed(ids) {
        let modal = {
            articleIds: ids,
        };
        return http.post("article/Article/articleEmployedListDownload", modal, { responseType: 'blob' });
    },
};
export default article;
